import React, { useEffect, useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { FileListData } from '@typings/ResidentTypes';
import { Role } from '@typings/ProfileTypes';
import uploadFile from '@api/upload-file';
import { acceptedLocalMediaFile, acceptedMultiFileTypes } from '@utils/commons';

interface UploadMultiDocumentsProps {
  userId: string;
  fileList: FileListData[];
  setFileList: React.Dispatch<React.SetStateAction<FileListData[]>>;
  uploadInputId: string;
  customizedButtonText?: string;
  type?: string;
}

const UploadMultiDocuments: React.FC<UploadMultiDocumentsProps> = ({
  userId,
  fileList,
  setFileList,
  uploadInputId,
  customizedButtonText,
  type,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [role, setRole] = useState('');

  useEffect(() => {
    setRole(localStorage.getItem('role') || '');
  }, []);

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (userId && file) {
      const formData = new FormData();
      formData.append('user_id', userId);
      formData.append('files', file);
      try {
        setIsUploading(true);
        const response: any = await uploadFile('document', formData);
        if (response && response.status === 'success') {
          const newFile = {
            name: file.name,
            data: response.data.data,
            id: uuidv4(),
          };
          setFileList([...(fileList || []), newFile]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsUploading(false);
        // eslint-disable-next-line no-param-reassign
        event.target.value = '';
      }
    }
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleButtonClick = (e: any) => {
    e.preventDefault();
    fileInputRef.current?.click();
  };

  return (
    <div>
      {customizedButtonText && (
        <button
          type="submit"
          className="govuk-button govuk-button--secondary govuk-!-margin-bottom-0"
          data-module="govuk-button"
          onClick={handleButtonClick}
          disabled={isUploading}
        >
          {customizedButtonText}
        </button>
      )}
      <input
        ref={fileInputRef}
        className="govuk-file-upload"
        id={uploadInputId}
        name="fileUpload1"
        type="file"
        accept={
          type === 'localMediaFile'
            ? acceptedLocalMediaFile.join(',')
            : acceptedMultiFileTypes.join(',')
        }
        onChange={handleFileUpload}
        disabled={isUploading || role === Role.TeamMemberViewOnly}
        hidden={!!customizedButtonText}
      />
    </div>
  );
};

UploadMultiDocuments.defaultProps = {
  customizedButtonText: '',
  type: undefined,
};

export default UploadMultiDocuments;
